import { ReactNode } from 'react';
import Polygon from '../Polygon';

interface EmojiChildBoxProps {
  children: ReactNode;
  icon: string;
  text: string;
  margin?: string; //크기에 따른 조정 필요
  align?: 'left' | 'right';
  bgColor?: string;
  textColor?: string;
  iconBgColor?: string;
  innerShadow?: boolean;
  shadowColor?: string;
  tail?: boolean;
  emojiRounded?: string;
  boxRounded?: string;
}

const EmojiChildrenLeftBox = ({
  children,
  icon,
  text,
  margin = '25%',
  bgColor = 'bg-white/65',
  textColor = 'text-black',
  iconBgColor = 'bg-white/65',
  innerShadow = false,
  shadowColor = 'shadow-green-800',
  tail = false,
  emojiRounded = 'rounded-full',
  boxRounded = 'rounded-2xl sm:rounded-3xl',
}: EmojiChildBoxProps) => {
  return (
    <div className="relative flex justify-start">
      <div
        className={`flex w-fit items-center gap-2 ${
          innerShadow ? `shadow-inner ${shadowColor}` : ''
        } ${bgColor} ${boxRounded} px-3 py-2 sm:px-5 sm:py-3`}
      >
        {/* 텍스트 컨테이너 */}
        <div
          style={{ order: 2 }}
          className={`${textColor} break-words text-left text-xs sm:text-base`}
        >
          {children}
        </div>
        {/* 이모지 컨테이너 */}
        <img
          src={icon}
          alt={text}
          className={`h-10 w-10 select-none p-2 sm:h-14 sm:w-14 ${iconBgColor} ${emojiRounded}`}
          style={{ order: 1 }}
        />
      </div>
      {/* 말풍선 꼬리 컨테이너 */}
      {tail && (
        <div className="absolute bottom-0 left-0 translate-x-10 translate-y-6">
          <Polygon color="#47B815" />
        </div>
      )}
    </div>
  );
};

const EmojiChildrenRightBox = ({
  children,
  icon,
  text,
  margin = '25%',
  bgColor = 'bg-white/65',
  textColor = 'text-black',
  iconBgColor = 'bg-white/65',
  innerShadow = false,
  shadowColor = 'shadow-green-800',
  tail = false,
  emojiRounded = 'rounded-full',
  boxRounded = 'rounded-2xl sm:rounded-3xl',
}: EmojiChildBoxProps) => {
  return (
    <div className="relative flex justify-end">
      <div
        className={`flex w-fit items-center gap-2 ${
          innerShadow ? `shadow-inner ${shadowColor}` : ''
        } justify-end ${bgColor} ${boxRounded} px-3 py-2 sm:px-5 sm:py-3`}
      >
        {/* 텍스트 컨테이너 */}
        <div
          style={{ order: 1 }}
          className={`${textColor} break-words text-right text-xs sm:text-base`}
        >
          {children}
        </div>
        <img
          src={icon}
          alt={text}
          className={`h-10 w-10 select-none p-2 sm:h-14 sm:w-14 ${iconBgColor} ${emojiRounded}`}
          style={{ order: 2 }}
        />
      </div>
      {/* 말풍선 꼬리 컨테이너 */}
      {tail && (
        <div className="absolute bottom-0 right-0 -translate-x-10 translate-y-6">
          <Polygon color="#47B815" />
        </div>
      )}
    </div>
  );
};

const EmojiChildrenBox = ({
  children,
  icon,
  text,
  align = 'left',
  margin = '25%',
  bgColor = 'bg-white/65',
  textColor = 'text-black',
  iconBgColor = 'bg-white/65',
  innerShadow = false,
  shadowColor = 'shadow-green-800',
  tail = false,
  emojiRounded = 'rounded-full',
}: EmojiChildBoxProps) => {
  const isRightAligned = align === 'right';

  return (
    <div className="relative w-full">
      <div
        className={`flex items-center gap-2 ${
          innerShadow ? `shadow-inner ${shadowColor}` : ''
        } ${
          isRightAligned ? 'justify-end' : 'justify-start'
        } ${bgColor} rounded-2xl px-3 py-2 sm:rounded-3xl sm:py-3 sm:pl-5 sm:pr-3 ${textColor} text-xs sm:text-base`}
        style={{
          textAlign: align,
          boxSizing: 'border-box',
          marginLeft: isRightAligned ? margin : 0,
          marginRight: isRightAligned ? 0 : margin,
        }}
      >
        <div style={{ order: isRightAligned ? 1 : 2 }}>{children}</div>
        <img
          src={icon}
          alt={text}
          className={`h-10 w-10 select-none p-2 sm:h-14 sm:w-14 ${iconBgColor} ${emojiRounded}`}
          style={{ order: isRightAligned ? 2 : 1 }}
        />
      </div>
      <div
        className={`absolute ${
          isRightAligned
            ? 'bottom-0 right-0 -translate-x-10 translate-y-6'
            : 'bottom-0 left-0 translate-x-10 translate-y-6'
        } ${tail ? '' : 'hidden'}`}
      >
        <Polygon color="#47B815" />
      </div>
    </div>
  );
};

export { EmojiChildrenLeftBox, EmojiChildrenRightBox, EmojiChildrenBox };
